<template>
	<div class="goods-info-body">
		<div class="goods-info-box">
			<div class="basis-info-body">
				<p>
					<span>基础信息</span>
					<span v-if="sourceflag">商品来源： 云供应链</span>
					<span v-if="sourceflag">品项状态：</span>
					<span v-show="pxstopflag"  v-if="sourceflag" style="color: red">停用</span>
					<span v-show="!pxstopflag"  v-if="sourceflag" style="color: #22A67A">启用</span>
					<el-button size="mini" plain type="primary"  v-if="sourceflag && (clddock === 1) && editDisable" @click="refresh">刷新</el-button>
				</p>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :inline-message='true' class="form-box">
					<div class="info-box">
						<el-form-item label="商品名称：" prop="goodsName">
							<el-input @blur="goodsNameBlur" :maxlength='50' v-model="ruleForm.goodsName" class="short-input" size="small" placeholder="请输入商品名称" :disabled="!editDisable"></el-input>
							<!-- <el-checkbox v-model="checked" :disabled="!editDisable">精选推荐</el-checkbox> -->
							<span style="color: #9E9C9D" v-if="sourceflag">
								品项名称： {{pxname}}
							</span>
						</el-form-item>
						<el-form-item label="商品编号：">
							<el-input v-model="ruleForm.code" class="short-input" size="small" @input="codeInput" maxlength="15" placeholder="请输入商品编号"></el-input>
							<!-- <el-checkbox v-model="checked" :disabled="!editDisable">精选推荐</el-checkbox> -->
							<span style="color: #9E9C9D" v-if="sourceflag">
								品项编号： {{pxcode}}
							</span>
						</el-form-item>
						<el-form-item label="所属品类：" prop='category' ref="category">
							<el-select v-model="ruleForm.bigCategory" class='short-input' size="small" placeholder="请选择店铺级大类" :disabled="!editDisable" @change="bigCategoryChange('ruleForm')">
								<template v-for="(item) in bigCategoryList">
									<el-option
										:value="item.bc_id"
										:label="item.bc_name"
										:key="item.bc_id"
										:disabled="item.disabledflag"/>
								</template>
							</el-select>
							<el-select v-model="ruleForm.smallCategory" class='short-input' v-if="bigcategoryview === 1" size="small" placeholder="请选择店铺级小类" :disabled="!editDisable" @change="smallCategoryChange('ruleForm')">
								<template v-for="(item) in smallCategoryList">
									<el-option
										:key="item.id"
										:label="item.name"
										:value="item.id"
										:disabled="item.disabledflag">
									</el-option>
								</template>
							</el-select>
							<el-button type='text' size="mini" style="margin-left:10px" @click="goClass">去设置商品分类</el-button>
						</el-form-item>
						<el-form-item label="商品介绍：">
							<el-input class='long-input' type="textarea" v-model="ruleForm.goodsExplain" :rows='4' :maxlength='300' placeholder='300字以内' :disabled="!editDisable"></el-input>
						</el-form-item>
					</div>
					<!-- <div class="status">
						<i
							v-show="auditShopCount !== 0"
							class="status-icon"
							:class="statusIcon"
						/>
					</div> -->
				</el-form>
			</div>
			<div class="show-img-body">
				<div class="img-box">
					<p>商品展示图</p>
					<div class="img-tips">长宽比例1:1，1M以内，格式：png/jpg/jpeg/gif</div>
					<div class="img-container">
						<ImgUpload
							class="show-img"
							v-for="(item, index) in showSrc.slice(0, 5)"
							:key="index"
							:location="item.location"
							:imgSrc.sync="item.src"
							:imgtype="item.imgtype"
							:imgId.sync="item.id"
							:uploadError.sync="item.uploadError"
							:statusIcon.sync="statusIcon"
							:editDisable="editDisable"
							ref="showUpload"
						/>
					</div>
				</div>
				<div class="img-box">
					<p>商品详情图</p>
					<div class="img-tips">宽800/长任意，1M以内，格式：png/jpg/jpeg/gif</div>
					<div class="img-container">
						<ImgUpload
							class="show-img"
							v-for="(item, index) in showSrc.slice(5)"
							:key="index"
							:location="item.location"
							:imgSrc.sync="item.src"
							:imgtype="item.imgtype"
							:imgId.sync="item.id"
							:uploadError.sync="item.uploadError"
							:statusIcon.sync="statusIcon"
							:editDisable="editDisable"
							ref="showUpload"
						/>
					</div>
				</div>
			</div>
			<div class="goods-status-box">
				<p>商品状态</p>
				<span>*</span>可售状态：
				<el-radio-group v-model="saleState" :disabled="!editDisable" @change="saleStateChange">
					<el-radio :label="1">可售</el-radio>
					<el-radio :label="0">不可售</el-radio>
				</el-radio-group>
				<div style="margin-top:10px">
					<span>*</span>商品私密状态：
					<el-radio-group v-model="hiddenFlag" :disabled="!editDisable">
						<el-radio :label="0">公开</el-radio>
						<el-radio :label="1">私密</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
		<div class="btn-box">
			<el-button class="btn" size='small' plain type="primary" @click="cancel" v-if="editDisable">取消</el-button>
			<el-button class="btn" size='small' type="primary" v-show="true" @click="saveInfo" v-if="editDisable">保存</el-button>
			<el-button class="btn" size='small' plain type="primary" v-show="true" v-if="auditShopCount !== 0 && statusIcon !== 'pass' && editDisable" @click="verify">申请审核</el-button>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@/components/goodsManagement/goodsInfo/ImgUpload.vue'
export default {
	name: 'goodsInfo',
	components: {
		ImgUpload
	},
	data () {
		var category = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('请完善品类'))
			} else {
				callback()
			}
		}
		return {
			hiddenFlag: 0,
			goodsid: '0',
			saleState: 1,
			auditShopCount: 0,
			statusIcon: 'submit',
			isTrue: true,
			checked: false,
			bigCategoryList: [],
			smallCategoryList: [],
			relatedStatus: false,
			ruleForm: {
				goodsName: '',
				bigCategory: '',
				smallCategory: '',
				goodsExplain: '',
				code: ''
			},
			rules: {
				goodsName: [
					{ required: true, message: '请输入商品名称', trigger: 'blur' }
				],
				category: [
					{ required: true, validator: category, trigger: 'blur' }
				]
			},
			showSrc: [
				{ src: '', location: '1', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '2', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '3', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '4', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '5', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '6', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '7', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '8', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '9', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '10', id: '0', uploadError: false, imgtype: 1 }
			],
			editDisable: true,
			pxcode: '',
			pxname: '',
			pxstopflag: false,
			clddock: 1,
			sourceflag: false,
			itemId: '',
			bigcategoryview: 0
		}
	},
	created () {
		this.getBigCategory()
		if (sessionStorage.getItem('goodsid')) {
			this.getGoodsInfo()
			this.getImgInfo()
			this.relatedStatusPost()
		} else {
			this.getInfo()
			this.checkSmallCategory().then(res => {
				this.bigcategoryview = res.bigcategoryview
				if (this.bigcategoryview === 1) {
					this.getSmalCategory()
				} else {
					this.isTrue = false
				}
			})
		}
		this.getAuthority('02_0001_0000_00')
	},
	methods: {
		codeInput () {
			this.ruleForm.code = this.ruleForm.code.replace(/\\|\'|[\u4E00-\u9FA5]/g, '')
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		// 去店铺级分类页
		goClass () {
			this.$fxEventBus.$emit('setMenu', '2-6')
			this.$router.push(`/main/categoryManagement`)
		},
		goodsNameBlur () {
			this.ruleForm.goodsName = this.ruleForm.goodsName.trim()
		},
		getInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
			}).then(res => {
				if (res.result) {
					this.hiddenFlag = res.data.privateflag
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					console.log(res)
					let a = res.data
					if (a.indexOf('02_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('goodsAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bigCategoryList = res.data
				}
			})
		},
		getSmalCategory () {
			return new Promise((resolve, reject) => {
				let params = {
					pid: this.ruleForm.bigCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						this.smallCategoryList = res.data
						resolve(res)
					}
				})
			})
		},
		bigCategoryChange (data) {
			this.ruleForm.smallCategory = ''
			this.categoryChange(data)
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		smallCategoryChange (data) {
			this.categoryChange(data)
		},
		categoryChange (formName) {
			if (this.ruleForm.bigCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallCategory === '')) {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('category', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		saveInfo () {
			this.$refs['ruleForm'].validate((valid) => {
				if (!valid) {
					return false
				} else {
					this.savePost()
				}
			})
		},
		translateImgArr (func) {
			return new Promise((resolve, reject) => {
				let previewArr = this.showSrc.reduce((pre, cur, index) => {
					let curSrc = this.$refs.showUpload[index][func]()
					if (curSrc) {
						pre.push(curSrc)
					}
					return pre
				}, [])
				if (previewArr.length === 0) {
					reject(previewArr)
				} else {
					resolve(previewArr)
				}
			})
		},
		savePost () {
			if (sessionStorage.getItem('goodsid')) {
				this.goodsid = sessionStorage.getItem('goodsid')
			}
			let params = {
				id: this.goodsid,
				bcId: this.ruleForm.bigCategory,
				scId: this.bigcategoryview === 1 ? this.ruleForm.smallCategory : 0,
				goodsName: this.ruleForm.goodsName,
				goodsExplain: this.ruleForm.goodsExplain,
				highQuality: this.checked ? 1 : 0,
				saleState: this.saleState,
				hiddenFlag: this.hiddenFlag,
				code: this.ruleForm.code
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/saveOrUpdateGoodsBaseInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					window.sessionStorage.setItem('goodsid', res.data.id)
					this.getGoodsInfo()
					this.auditShopCount = 0
					switch (res.data.auditState) {
					case 0:
						this.statusIcon = 'submit'
						break
					case 1:
						this.statusIcon = 'pending'
						break
					case 2:
						this.statusIcon = 'pass'
						break
					case 3:
						this.statusIcon = 'reject'
						break
					}
					this.translateImgArr('hasImgFile').then(arr => {
						this.uploadAsync(arr)
					}).catch(() => {
						this.$message.success('保存成功！')
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		uploadAsync: async function (uploadFileArr) {
			for (let i = 0; i < uploadFileArr.length; i++) {
				await this.$refs.showUpload[uploadFileArr[i] - 1].uploadImgHandler()
			}
			this.$message.success('保存成功！')
		},
		getGoodsInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				bcId: '0',
				scId: '0',
				goodsName: '',
				saleState: 2,
				auditState: 4,
				page: 1,
				size: 20,
				order: 1,
				orderKey: '',
				hiddenFlag: +sessionStorage.getItem('goodHiddenFlag'),
				sourceflag: -1,
				unitFlag: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data.recordList[0]
					window.sessionStorage.setItem('goodName', data.goodsName)
					this.ruleForm.goodsName = data.goodsName
					if (data.highQuality === '是') {
						this.checked = true
					} else {
						this.checked = false
					}
					this.auditShopCount = 0
					this.pxstopflag = data.pxstopflag
					this.pxname = data.pxname
					this.pxcode = data.pxcode
					this.sourceflag = data.sourceflag
					this.hiddenFlag = data.hiddenFlag
					this.itemId = data.itemId
					this.clddock = res.data.clddock
					this.saleState = data.saleState === '不可售' ? 0 : 1
					this.ruleForm.goodsExplain = data.goodsExplain
					this.ruleForm.bigCategory = data.bcId
					this.ruleForm.code = data.code
					this.checkSmallCategory().then(res => {
						this.bigcategoryview = res.bigcategoryview
						if (this.bigcategoryview === 1) {
							this.getSmalCategory().then(() => {
								this.ruleForm.smallCategory = data.scId === '0' ? '' : data.scId
								this.categoryChange('ruleForm')
							})
						} else {
							this.isTrue = false
						}
					})
					// this.getSmalCategory().then(() => {
					// 	this.ruleForm.smallCategory = data.scId
					// 	this.categoryChange('ruleForm')
					// })
					switch (data.auditState) {
					case '待提交':
						this.statusIcon = 'submit'
						break
					case '待审核':
						this.statusIcon = 'pending'
						break
					case '通过':
						this.statusIcon = 'pass'
						break
					case '驳回':
						this.statusIcon = 'reject'
						break
					}
				}
			})
		},
		getImgInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsImgInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.showSrc.forEach(item => {
						res.data.forEach(dataItem => {
							if (item.location === '' + dataItem.imgsort) {
								item.src = dataItem.imgurl
								item.id = dataItem.id
							}
						})
					})
				}
			})
		},
		cancel () {
			this.showSrc.forEach((item, index) => {
				this.$refs.showUpload[index].returnSrc()
			})
			if (sessionStorage.getItem('goodsid')) {
				this.getGoodsInfo()
				this.getImgInfo()
			} else {
				this.ruleForm.goodsName = ''
				this.checked = false
				this.ruleForm.bigCategory = ''
				this.ruleForm.smallCategory = ''
				this.ruleForm.goodsExplain = ''
				this.saleState = 1
				this.showSrc.forEach((item, index) => {
					this.$refs.showUpload[index].returnSrc()
				})
			}
		},
		verify () {
			let params = {
				ids: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/saveOrUpdateProductBase`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('申请审核成功！')
					this.statusIcon = 'pending'
				} else {
					this.$message.error('申请审核失败！')
				}
			})
		},
		saleStateChange (value) {
			if (sessionStorage.getItem('goodsid')) {
				if (value === 0 && this.statusIcon === 'pass' && this.relatedStatus) {
					this.$message({
						message: '修改后商城中商品变为不可售状态！',
						type: 'warning',
						duration: 3000
					})
				}
			}
		},
		relatedStatusPost () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				shopName: '',
				comFlag: 0,
				size: 20,
				page: 1,
				order: 1,
				orderKey: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getShopInfoOfProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.relatedStatus = res.data.recordCount > 0
				}
			})
		},
		refresh () {
			let params = {
				itemId: this.itemId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dockcld/refreshCldGoodsStopFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.pxstopflag = res.data.mdStopFLag
					this.$message.success('刷新成功！')
				} else {
					this.$message.error(res.msg)
				}
			}).catch((e) => {
				this.$message.error(e.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.goods-info-body {
	display flex
	flex: 1
	height: calc(100% - 75px)
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.goods-info-box {
		overflow-y auto
		display flex
		flex 1
		flex-direction column
		.basis-info-body {
			padding-top: 20px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			p {
				height 20px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				position relative
				color: #9E9C9D
				font-size 14px
				span {
					&:first-child {
						font-size 16px
						color: #2c3e50
					}
					&:nth-of-type(2) {
						margin: 0 30px;
					}
				}
				.el-button {
					position absolute
					margin-left 30px;
					top: -4px;
				}
			}
			.form-box {
				display flex
				padding-top 10px
				.info-box {
					flex: 8
					.short-input {
						width: 200px
						&:nth-of-type(1) {
							margin-right 20px
						}
					}
				}
				.status {
					flex: 7
					.status-icon {
						display inline-block
						width: 108px
						height: 56px
					}
					.pass {
						background-image: url('~images/icon/pass.png')
					}
					.pending {
						background-image: url('~images/icon/pending.png')
					}
					.reject {
						background-image: url('~images/icon/reject.png')
					}
					.submit {
						background-image: url('~images/icon/submit.png')
					}
				}
			}
		}
		.show-img-body {
			padding: 20px 0
			min-height: 440px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			display flex
			.img-box {
				flex: 1
				p {
					height 20px
					font-size 16px
					line-height 20px
					border-left 4px solid var(--fx-primary-color)
					padding-left 8px
				}
				.img-container {
					max-width: 600px
				}
				.img-tips {
					padding: 20px 0 20px 12px
					color: #a7a7a7
				}
			}
		}
		.goods-status-box {
			text-align left
			p {
				height 20px
				font-size 16px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				margin 20px 0
			}
			span {
				color: red
				margin-right 6px
			}
		}
	}
	.btn-box {
		padding: 20px 0
		text-align left
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}

</style>
